import React from 'react';
import { Row, Col } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ButtonTheme } from '../../../components/buttons';
import { useMediaQuery } from 'react-responsive';
import { BREAKE_POINT, GUTTER_LAYOUT } from '../../../resources';
// Ant icons removed: using image assets instead
// white / color asset icons
import wifiWhite from '../../../assets/icons/icon_Web_White/wifi.svg';
import wifiColor from '../../../assets/icons/icon_Web_Color/wifi.svg';
import waterWhite from '../../../assets/icons/icon_Web_White/water_phone.svg';
import waterColor from '../../../assets/icons/icon_Web_Color/water_phone.svg';
import screenWhite from '../../../assets/icons/icon_Web_White/screen.svg';
import screenColor from '../../../assets/icons/icon_Web_Color/screen.svg';
import powerWhite from '../../../assets/icons/icon_Web_White/power.svg';
import powerColor from '../../../assets/icons/icon_Web_Color/power.svg';
import micWhite from '../../../assets/icons/icon_Web_White/micophone.svg';
import micColor from '../../../assets/icons/icon_Web_Color/micophone.svg';
import frontWhite from '../../../assets/icons/icon_Web_White/front_camera.svg';
import frontColor from '../../../assets/icons/icon_Web_Color/front_camera.svg';
import faceWhite from '../../../assets/icons/icon_Web_White/face_lock.svg';
import faceColor from '../../../assets/icons/icon_Web_Color/face_lock.svg';
import chagerWhite from '../../../assets/icons/icon_Web_White/chager.svg';
import chagerColor from '../../../assets/icons/icon_Web_Color/chager.svg';
import callWhite from '../../../assets/icons/icon_Web_White/call_phone.svg';
import callColor from '../../../assets/icons/icon_Web_Color/call_phone.svg';
import backWhite from '../../../assets/icons/icon_Web_White/back_camera.svg';
import backColor from '../../../assets/icons/icon_Web_Color/back_camera.svg';
import alertWhite from '../../../assets/icons/icon_Web_White/alert_phone.svg';
import alertColor from '../../../assets/icons/icon_Web_Color/alert_phone.svg';

import {
  CONDITIONUC101,
  CONDITIONUC102,
  CONDITIONUC103,
  CONDITIONUC104,
  CONDITIONUC105,
  CONDITIONUC106,
  CONDITIONUC107,
  CONDITIONUC110,
  CONDITIONUC111,
  CONDITIONUC112,
  CONDITIONUC113,
} from '../constant';

const DEFAULT_USED_COND_ICON = { white: alertWhite, color: alertColor };

// ใช้ข้อมูลเงื่อนไขที่ให้มา (UC101..UC114)
const USED_COND_ICON_MAP = {
  'UC-101': {
    icon: { white: backWhite, color: backColor },
    label: 'กล้องหลัง',
    helpData: CONDITIONUC101,
  },
  'UC-102': {
    icon: { white: backWhite, color: backColor },
    label: 'กล้องหลังมีปัญหา/จุดดำ > 2/เลเซอร์',
    helpData: CONDITIONUC102,
  },
  'UC-114': {
    icon: { white: frontWhite, color: frontColor },
    label: 'กล้องหน้า',
    helpData: CONDITIONUC102,
  },
  'UC-103': {
    icon: { white: micWhite, color: micColor },
    label: 'ไมค์ / ลำโพง',
    helpData: CONDITIONUC103,
  },
  'UC-104': {
    icon: { white: powerWhite, color: powerColor },
    label: 'ปุ่มกด',
    helpData: CONDITIONUC104,
  },
  'UC-105': {
    icon: { white: chagerWhite, color: chagerColor },
    label: 'ช่องชาร์จ / ระบบชาร์จ',
    helpData: CONDITIONUC105,
  },
  'UC-106': {
    icon: { white: screenWhite, color: screenColor },
    label: 'หน้าจอ / ระบบสัมผัส',
    helpData: CONDITIONUC106,
  },
  'UC-107': {
    icon: { white: faceWhite, color: faceColor },
    label: 'สแกนหน้า / สแกนนิ้ว',
    helpData: CONDITIONUC107,
  },
  'UC-108': {
    icon: { white: faceWhite, color: faceColor },
    label: 'Face/Touch ID มีปัญหา',
  },
  'UC-109': { icon: DEFAULT_USED_COND_ICON, label: 'ระบบสั่นมีปัญหา', },
  'UC-110': {
    icon: DEFAULT_USED_COND_ICON,
    label: 'เซ็นเซอร์ / ระบบสั่น / Panicfull',
    displayLabel: 'เซ็นเซอร์ / ระบบสั่น',
    helpData: CONDITIONUC110,
  },
  'UC-111': {
    icon: { white: callWhite, color: callColor },
    label: 'โทรออกรับสาย',
    helpData: CONDITIONUC111,
  },
  'UC-112': {
    icon: { white: wifiWhite, color: wifiColor },
    label: 'Wi-Fi / Bluetooth / GPS',
    helpData: CONDITIONUC112,
  },
  'UC-113': {
    icon: { white: waterWhite, color: waterColor },
    label: 'ตกน้ำ / เครื่องร้อนผิดปกติ',
    helpData: CONDITIONUC113,
  },
};

const IconImageSwap = ({ icon, selected }) => (
  <div style={{ position: 'relative', width: 80, height: 80, margin: '0 auto' }}>
    <img
      src={icon.white}
      alt=""
      draggable={false}
      decoding="async"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        opacity: selected ? 0 : 1,
        transition: 'opacity .15s ease',
      }}
    />
    <img
      src={icon.color}
      alt=""
      draggable={false}
      decoding="async"
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        opacity: selected ? 1 : 0,
        transition: 'opacity .15s ease',
      }}
    />
  </div>
);

const IconOption = React.memo(function IconOption({
  selected,
  icon,
  label,
  onClick,
  disabled,
  onHelpClick,
}) {
  return (
    <div
      onClick={() => {
        if (!disabled) onClick();
      }}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        textAlign: 'center',
        userSelect: 'none',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        position: 'relative',
      }}
    >
      {icon && icon.white && icon.color ? (
        <IconImageSwap icon={icon} selected={selected} />
      ) : (
        <span style={{ marginTop: 4, fontSize: 20, color: selected ? '#4FA1A4' : '#333' }}>
          {/* fallback icon jsx */}
        </span>
      )}
      <div
        style={{
          fontSize: 18,
          lineHeight: 1.2,
          color: selected ? '#4FA1A4' : '#000',
          fontWeight: selected ? 600 : 400,
          minHeight: 32,
          marginTop: 8,
          fontFamily: 'HeaventRoundedMedium, sans-serif',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {label}
        {onHelpClick && (
          <QuestionCircleOutlined
            style={{
              color: '#999',
              cursor: 'pointer',
              position: 'absolute',
              right: -25,
              top: '45%',
              transform: 'translateY(-50%)',
            }}
            onClick={(e) => {
              e.stopPropagation();
              onHelpClick();
            }}
          />
        )}
      </div>
    </div>
  );
});

export const LISTFORMSTEPONE = ({ list = {}, fn = {}, dataStepOne = {} }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const hardStop = dataStepOne?.frameConditionId === 'FR-000';
  const {
    region = [],
    warranty = [],
    frameCondition = [],
    displayCondition = [],
    backCoverCondition = [],
    backCameraConditions = [],
    battery = [],
    accessories = [],
    usedCondition = [],
  } = list;
  const { handleSelect = () => null, handleHelp = () => null } = fn;

  return [
    {
      key: '1',
      label: '1. Model เครื่อง',
      texthelp: 'วิธีตรวจ Model เครื่อง',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {region.map((elRegion) => {
            return (
              <Col key={elRegion.value} {...BREAKE_POINT?.OTHER_COUTENT_SIX}>
                <ButtonTheme
                  type={dataStepOne?.regionId === elRegion.value && 'primary'}
                  onClick={() => handleSelect('1', elRegion.value)}
                  useFor="MESSAGE"
                  title={elRegion.label}
                  style={{ width: '100%', fontSize: !isMobile ? '22px' : '18px' }}
                />
              </Col>
            );
          })}
        </Row>
      ),
    },
    {
      key: '2',
      label: '2. ความคุ้มครอง (ประกัน)',
      texthelp: 'วิธีตรวจประกัน',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {warranty.map((elWarranty) => {
            return (
              <Col key={elWarranty.value} {...BREAKE_POINT?.OTHER_COUTENT_THREE}>
                <ButtonTheme
                  type={dataStepOne?.warrantyId === elWarranty.value ? 'primary' : 'default'}
                  onClick={() => handleSelect('2', elWarranty.value)}
                  useFor="MESSAGE"
                  title={elWarranty.label}
                  style={{
                    width: '100%',
                    fontSize: !isMobile ? '22px' : '18px',
                    height: !isMobile ? '80px' : '60px',
                  }}
                />
              </Col>
            );
          })}
        </Row>
      ),
    },
    {
      key: '3',
      label: '3. สภาพตัวเครื่อง',
      texthelp: 'วิธีตรวจตัวเครื่อง',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {frameCondition.map((elFrameCondition) => {
            return (
              <Col key={elFrameCondition.value} {...BREAKE_POINT?.OTHER_COUTENT_THREE}>
                <ButtonTheme
                  type={dataStepOne?.frameConditionId === elFrameCondition.value && 'primary'}
                  onClick={() => handleSelect('3', elFrameCondition.value)}
                  useFor="MESSAGE"
                  title={elFrameCondition.label}
                  style={{
                    width: '100%',
                    fontSize: !isMobile ? '22px' : '18px',
                    height: !isMobile ? '80px' : '60px',
                  }}
                />
              </Col>
            );
          })}
        </Row>
      ),
    },

    {
      key: '4',
      label: '4. สภาพหน้าจอ',
      texthelp: 'วิธีตรวจหน้าจอ',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {displayCondition.map((elDisplayCondition) => (
            <Col key={elDisplayCondition.value} {...BREAKE_POINT?.OTHER_COUTENT_THREE}>
              <ButtonTheme
                disabled={hardStop} // ✅ disable เมื่อ FR-000
                type={dataStepOne?.displayConditionId === elDisplayCondition.value && 'primary'}
                onClick={() => {
                  if (!hardStop) handleSelect('4', elDisplayCondition.value);
                }}
                useFor="MESSAGE"
                title={elDisplayCondition.label}
                style={{
                  width: '100%',
                  fontSize: !isMobile ? '22px' : '18px',
                  opacity: hardStop ? 0.5 : 1,
                  pointerEvents: hardStop ? 'none' : 'auto',
                }}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: '5',
      label: '5. สภาพฝาหลัง',
      texthelp: 'วิธีตรวจฝาหลัง',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {backCoverCondition.map((elBackCoverCondition) => (
            <Col key={elBackCoverCondition.value} {...BREAKE_POINT?.OTHER_COUTENT_THREE}>
              <ButtonTheme
                disabled={hardStop}
                type={dataStepOne?.backCoverConditionId === elBackCoverCondition.value && 'primary'}
                onClick={() => {
                  if (!hardStop) handleSelect('5', elBackCoverCondition.value);
                }}
                useFor="MESSAGE"
                title={elBackCoverCondition.label}
                style={{
                  width: '100%',
                  fontSize: !isMobile ? '22px' : '18px',
                  height: !isMobile ? '80px' : '60px',
                  opacity: hardStop ? 0.5 : 1,
                  pointerEvents: hardStop ? 'none' : 'auto',
                }}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: '6',
      label: '6. สภาพกล้องหลัง',
      texthelp: 'วิธีตรวจกล้องหลัง',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {backCameraConditions.map((elBackCameraConditions) => (
            <Col key={elBackCameraConditions.value} {...BREAKE_POINT?.OTHER_COUTENT_SEVEN}>
              <ButtonTheme
                disabled={hardStop}
                type={
                  dataStepOne?.backCameraConditionId === elBackCameraConditions.value && 'primary'
                }
                onClick={() => {
                  if (!hardStop) handleSelect('6', elBackCameraConditions.value);
                }}
                useFor="MESSAGE"
                title={elBackCameraConditions.label}
                style={{
                  width: '100%',
                  fontSize: !isMobile ? '22px' : '18px',
                  height: !isMobile ? '80px' : '60px',
                  opacity: hardStop ? 0.5 : 1,
                  pointerEvents: hardStop ? 'none' : 'auto',
                }}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: '7',
      label: '7. สุขภาพแบตเตอรี่',
      texthelp: 'วิธีตรวจสุขภาพแบตเตอรี่',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {battery.map((elBattery) => (
            <Col key={elBattery.value} {...BREAKE_POINT?.OTHER_COUTENT_SEVEN}>
              <ButtonTheme
                disabled={hardStop}
                type={dataStepOne?.batteryId === elBattery.value && 'primary'}
                onClick={() => {
                  if (!hardStop) handleSelect('7', elBattery.value);
                }}
                useFor="MESSAGE"
                title={elBattery.label}
                style={{
                  width: '100%',
                  fontSize: !isMobile ? '22px' : '18px',
                  opacity: hardStop ? 0.5 : 1,
                  pointerEvents: hardStop ? 'none' : 'auto',
                }}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: '8',
      label: '8. กล่องและอุปกรณ์',
      texthelp: 'ตัวอย่างอุปกรณ์เสริม',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {accessories.map((elAccessories) => (
            <Col key={elAccessories.value} {...BREAKE_POINT?.OTHER_COUTENT_SEVEN}>
              <ButtonTheme
                disabled={hardStop}
                type={dataStepOne?.accessoryId === elAccessories.value && 'primary'}
                onClick={() => {
                  if (!hardStop) handleSelect('8', elAccessories.value);
                }}
                useFor="MESSAGE"
                title={elAccessories.label}
                style={{
                  width: '100%',
                  fontSize: !isMobile ? '22px' : '18px',
                  opacity: hardStop ? 0.5 : 1,
                  pointerEvents: hardStop ? 'none' : 'auto',
                }}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: '9',
      label: (
        <span>
          {'9. ปัญหาด้านการใช้งาน (เลือกได้มากกว่า 1 ข้อ) '}{' '}
          <span style={{ color: 'red' }}>{'หากเครื่องไม่มีปัญหา กดประเมินราคาได้เลย'}</span>
        </span>
      ),
      texthelp: 'วิธีตรวจสภาพการใช้งานเบื้องต้น',
      content: (
        <Row gutter={GUTTER_LAYOUT?.MAIN_CONTENT}>
          {usedCondition.map((opt) => {
            const map = USED_COND_ICON_MAP[opt.value] || {
              icon: DEFAULT_USED_COND_ICON,
              label: opt.label,
            };
            const selected = Array.isArray(dataStepOne?.usedCondition)
              ? dataStepOne?.usedCondition.includes(opt.value)
              : false;

            return (
              <Col key={opt.value} {...BREAKE_POINT?.OTHER_COUTENT_SEVEN}>
                <IconOption
                  disabled={hardStop} // ✅ disable เมื่อ FR-000
                  selected={selected}
                  icon={map.icon}
                  label={map.displayLabel || map.label || opt.label}
                  onClick={() => handleSelect('9', opt.value)}
                  onHelpClick={map.helpData ? () => handleHelp(map.helpData, map.label) : undefined}
                />
              </Col>
            );
          })}
        </Row>
      ),
    },
  ];
};

const INFO = [
  {
    name: 'firstName',
    label: 'ชื่อ',
    type: 'INPUT',
    placeholder: 'กรอกชื่อ',
    span: 12,
    rules: {
      required: true,
    },
  },
  {
    name: 'lastName',
    label: 'นามสกุล',
    type: 'INPUT',
    placeholder: 'กรอกนามสกุล',
    span: 12,
    rules: {
      required: true,
    },
  },
  {
    name: 'tel',
    label: 'เบอร์ติดต่อ',
    type: 'INPUT_NUMBERIC',
    placeholder: 'กรอกเบอร์ติดต่อ',
    span: 12,
    rules: {
      required: true,
      maxLength: 10,
      pattern: {
        message: 'โปรดกรอกตัวเลข 10 หลัก',
        value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g, //pattern
      },
    },
  },
  {
    name: 'lineId',
    label: 'ไลน์ไอดี',
    type: 'INPUT',
    placeholder: 'กรอกไลน์ไอดี',
    span: 12,
  },
  {
    name: 'email',
    label: 'อีเมล',
    type: 'INPUT',
    placeholder: 'กรอกอีเมล',
    span: 12,
    rules: {
      validate: (value) =>
        !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'อีเมลไม่ถูกต้อง',
    },
  },
];

export const FORM_BOOKING_DETAIL = ({ optionsBranch = [] }) => {
  return [
    {
      name: 'branch',
      label: 'สาขา Apple House',
      type: 'DROPDOWN',
      placeholder: 'เลือกสาขา Apple House',
      span: 24,
      properties: {
        options: optionsBranch || [],
      },
      rules: {
        required: true,
      },
    },
    ...INFO,
  ];
};

export const FORM_BOOKING_DETAIL_MAP = ({ options, isButtonAddressEnabled }) => {
  const { province, district, subDistrict } = options;
  return [
    {
      name: 'street',
      label: 'รายละเอียดที่อยู่',
      type: 'INPUT_AREA',
      placeholder:
        'รายละเอียดที่อยู่ (โปรดระบุที่อยู่ ที่คุณสะดวกให้เข้ารับมือถือ)\nนอกสถานที่ให้บริการเฉพาะกรุงเทพฯ และปริมลฑลเท่านั้น\nต่างจังหวัดหากต้องการขายไอโฟน ไอแพด รบกวนติดต่อแอดมิน โทร. 09-5319-4700',
      span: 24,
      rows: 4,
      rules: {
        required: {
          value: true,
        },
      },
    },
    {
      name: 'postalCode',
      label: 'รหัสไปรษณีย์',
      type: 'INPUT_NUMBERIC',
      placeholder: 'เฉพาะกรุงเทพฯ และปริมลฑลเท่านั้น',
      span: 12,
      tooltipLabel: 'เฉพาะกรุงเทพและปริมลฑลเท่านั้น',
      rules: {
        required: true,
        maxLength: 5,
        pattern: {
          message: 'โปรดกรอกตัวเลข',
          //value: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/g, //pattern
        },
      },
    },
    {
      name: 'province',
      label: 'จังหวัด',
      type: 'DROPDOWN',
      placeholder: 'เลือกจังหวัด',
      span: 12,
      disabled: !isButtonAddressEnabled,
      properties: {
        options: province || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'district',
      label: 'เขต/อำเภอ',
      type: 'DROPDOWN',
      placeholder: 'เลือกเขต/อำเภอ',
      disabled: !isButtonAddressEnabled,
      span: 12,
      properties: {
        options: district || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'subdistrict',
      label: 'แขวง/ตำบล',
      type: 'DROPDOWN',
      placeholder: 'เลือกแขวง/ตำบล',
      disabled: !isButtonAddressEnabled,
      span: 12,
      properties: {
        options: subDistrict || [],
      },
      rules: {
        required: true,
      },
    },
    ...INFO,
  ];
};
